import api from './client'

// Consulta de stock a depósito: Ventas pide desde la NV, depósito responde
// desde LGR móvil (con sesión) o por el link de Telegram (token, sin sesión).
export const consultasStockApi = {
  crear: (nvId, data) => api.post(`/notas-venta/${nvId}/consultas-stock`, data),
  deNv: (nvId) => api.get(`/notas-venta/${nvId}/consultas-stock`),
  listar: (params) => api.get('/consultas-stock', { params }),
  pendientesDeposito: () => api.get('/consultas-stock/pendientes-deposito'),
  // #124: cuáles de estos artículos figuran sin stock en LGR (el modal pregunta si se consultan igual).
  sinStock: (ids) => api.get('/consultas-stock/sin-stock', { params: { ids: ids.join(',') } }),
  ver: (id) => api.get(`/consultas-stock/${id}`),
  responder: (id, respuestas) => api.post(`/consultas-stock/${id}/responder`, { respuestas }),
  cancelar: (id) => api.post(`/consultas-stock/${id}/cancelar`),
  verPorToken: (token) => api.get(`/publico/consultas-stock/${token}`),
  responderPorToken: (token, respuestas) => api.post(`/publico/consultas-stock/${token}/responder`, { respuestas }),
}

// Avisos de stock bajo de depósito: alimentan el informe de reposición de los lunes.
export const stockBajoApi = {
  buscar: (codigo) => api.get('/stock-bajo/buscar', { params: { codigo } }),
  avisar: (data) => api.post('/stock-bajo', data),
  listar: (params) => api.get('/stock-bajo', { params }),
}
